"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var GestureSwapRight = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_GestureSwapRight_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 12,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.315 3.86a.476.476 0 0 1-.675 0 .483.483 0 0 1 0-.68l.675-.68-.675-.68a.483.483 0 0 1 0-.68.476.476 0 0 1 .675 0l1.067 1.074a.406.406 0 0 1 0 .572L7.315 3.859Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 3.648c0-1.098 1.43-1.615 2.066-.63l1.428 2.216a1.257 1.257 0 0 1 1.764.186l.387.467a1.204 1.204 0 0 1 1.619-.011L11.53 7.44c.412.365.678.87.754 1.417l.142 1.032c.125.906.39 1.784.786 2.6l.469.971-5.152 2.131-.994-1.028a.37.37 0 0 0-.109-.078l-3.808-1.79a1.7 1.7 0 0 1-.93-1.864 6.546 6.546 0 0 1 1.125-2.6l.258-.356-1.303-2.953A3.16 3.16 0 0 1 2.5 3.648Zm1.972 5.39a5.558 5.558 0 0 0-.802 1.984.7.7 0 0 0 .374.769l3.808 1.79c.15.07.286.168.402.287l.521.54 3.544-1.466-.008-.016a9.713 9.713 0 0 1-.875-2.899l-.143-1.032a1.316 1.316 0 0 0-.426-.805L9.1 6.624a.21.21 0 0 0-.313.037l.366.442a.5.5 0 1 1-.77.638L6.988 6.058a.265.265 0 0 0-.439.037l.948 1.47a.5.5 0 0 1-.84.542L3.725 3.56c-.025-.04-.048-.05-.062-.055a.114.114 0 0 0-.07.001.133.133 0 0 0-.065.045.151.151 0 0 0-.028.097c0 .301.063.598.183.871l1.43 3.24.82 2.566a.5.5 0 0 1-.953.305l-.508-1.592Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14 3.86a.476.476 0 0 0 .675 0l1.067-1.074a.405.405 0 0 0 0-.572L9.815 1.141a.476.476 0 0 0-.675 0 .483.483 0 0 0 0 .68l.675.679-.675.68a.483.483 0 0 0 0 .68Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_GestureSwapRight_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = GestureSwapRight;
exports["default"] = _default;